module.exports = __webpack_public_path__ + "img/benefit.b3554fb.svg";